var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgXmark = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 11,
  height: 11,
  viewBox: "0 0 11 11",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.0772 0.53033C10.3701 0.823223 10.3701 1.2981 10.0772 1.59099L1.59192 10.0763C1.29903 10.3692 0.824157 10.3692 0.531264 10.0763C0.23837 9.78338 0.238371 9.3085 0.531264 9.01561L9.01654 0.53033C9.30944 0.237437 9.78431 0.237437 10.0772 0.53033Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M1.06159 1.06062L9.54688 9.5459",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgXmark;